import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
} from "@material-ui/core";
import { ArrowBackIosSharp, CancelOutlined } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import {
  getDate,
  manualAdviceTabsPath,
  rebalance_sell_path,
} from "../utils/varialbles";
import {
  DataSheetGrid,
  checkboxColumn,
  textColumn,
  keyColumn,
} from "react-datasheet-grid";
import "react-datasheet-grid/dist/style.css";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { ReinvestingPlan } from "../pdfreact/ReinvestingPlan";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { convertToHTML } from "draft-convert";
import DOMPurify from "dompurify";
import { ExitPlan } from "../pdfreact/ExitPlan";

function RebalanceOverallData() {
  const location = useLocation();
  const history = useHistory();

  const [sellData, setSellData] = useState([]);
  const [BuyData, setBuyData] = useState([]);
  const [customerName, setcustomerName] = useState("");
  const [pdfName, setpdfName] = useState("");

  const previewSellcolumn = [
    {
      ...keyColumn("stockname", textColumn), //checkboxColumn
      title: "Asset Name",
      disabled: true,
    },
    {
      ...keyColumn("action", textColumn),
      title: "Action",
      disabled: true,
    },
    {
      ...keyColumn("assettype", textColumn),
      title: "Asset Type",
      disabled: true,
    },
    {
      ...keyColumn("ISINCode", textColumn),
      title: "ISIN Code",
      disabled: true,
    },
    {
      ...keyColumn("amount", textColumn),
      title: "Amount",
      disabled: true,
    },
  ];

  const previewBuycolumn = [
    {
      ...keyColumn("stockname", textColumn), //checkboxColumn
      title: "Asset Name",
      disabled: true,
    },
    {
      ...keyColumn("action", textColumn),
      title: "Action",
      disabled: true,
    },
    {
      ...keyColumn("assettype", textColumn),
      title: "Asset Type",
      disabled: true,
    },
    {
      ...keyColumn("ISINCode", textColumn),
      title: "ISIN Code",
      disabled: true,
    },
    {
      ...keyColumn("amount", textColumn),
      title: "Amount",
      disabled: true,
    },
  ];

  const sellCols = [
    {
      label: "ID",
      id: "id",
    },
    {
      label: "ISIN Number",
      id: "ISINCode",
    },
    {
      label: "Asset Type",
      id: "assettype",
    },
    {
      label: "Asset Name",
      id: "stockname",
    },
    {
      label: "Sell Amount",
      id: "amount",
    },
    {
      label: "Country",
      id: "country",
    },
    {
      label: "Created Date",
      type: "date",
      id: "createddt",
    },
    {
      label: "Updated Date",
      type: "date",
      id: "updateddt",
    },
    // {
    //   label: "Edit",
    //   tyep: "button",
    //   id: "",
    // },
    // {
    //   label: "Delete",
    //   tyep: "button",
    //   id: "",
    // },
  ];

  const buyCols = [
    {
      label: "ID",
      id: "id",
    },
    {
      label: "ISIN Number",
      id: "ISINCode",
    },
    {
      label: "Asset Type",
      id: "assettype",
    },
    {
      label: "Asset Name",
      id: "stockname",
    },
    {
      label: "Buy Amount",
      id: "amount",
    },
    {
      label: "Country",
      id: "country",
    },
    {
      label: "Created Date",
      type: "date",
      id: "createddt",
    },
    {
      label: "Updated Date",
      type: "date",
      id: "updateddt",
    },
    // {
    //   label: "Edit",
    //   tyep: "button",
    //   id: "",
    // },
    // {
    //   label: "Delete",
    //   tyep: "button",
    //   id: "",
    // },
  ];

  const [editorAbovetable, seteditorAbovetable] = useState(() =>
    EditorState.createEmpty()
  );
  const [editorBelowtable, seteditorBelowtable] = useState(() =>
    EditorState.createEmpty()
  );
  const [convertedContentAboveTable, setconvertedContentAboveTable] =
    useState(null);
  const [convertedContentBelowTable, setConvertedContentBelowTable] =
    useState(null);

  const _contentState = ContentState.createFromText("Enter Text Here");
  const raw = convertToRaw(_contentState); // RawDraftContentState JSON
  const [contentState, setContentState] = useState(raw);

  useEffect(() => {
    let html = convertToHTML(editorAbovetable.getCurrentContent());
    setconvertedContentAboveTable(html);
  }, [editorAbovetable]);

  useEffect(() => {
    let html = convertToHTML(editorBelowtable.getCurrentContent());
    setConvertedContentBelowTable(html);
  }, [editorBelowtable]);

  const [showPDFeditfields, setshowPDFeditfields] = useState(false);
  const PDFeditfields = () => {
    setshowPDFeditfields(true);
  };

  let investorname = pdfName
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  const [setPreview, setShowPreview] = useState(false);
  const [setSellPreview, setShowSellPreview] = useState(false);

  const preview = () => {
    setShowPreview(true);
  };

  const closepreview = () => {
    setShowPreview(false);
  };

  const getData = () => {
    toast.loading("Please wait...");
    http
      .get(`advicerebalancerequestsbyid/${location.request_id}`)
      .then((res) => {
        toast.dismiss();

        const response = res.data.Data;

        let Sell = [];
        Sell = response.filter((item) => {
          if (item.type === "S") {
            return item;
          }
        });
        setSellData(Sell);
        let Buy = [];
        Buy = response.filter((item) => {
          if (item.type === "B") {
            return item;
          }
        });
        setBuyData(Buy);
        setcustomerName(res.data.customer); //Name for PDF
        // console.log(Buy);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const sendRebalanceAdvice = () => {
    http
      .get(`sendRebalanceAdvice/${location.request_id}`)
      .then((res) => {
        if (res.data.statusCode === 0) {
          toast.success(res.data.Data);

          history.push({
            pathname: manualAdviceTabsPath,
          });
        } else {
          toast.error(res.data.Data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const gotoManualadvices = () => {
    history.push({
      pathname: rebalance_sell_path,
      // sForm: location.sellForm,
      // bForm: location.buyForm,
      sForm: sellData,
      bForm: BuyData,
      request_id: location.request_id,
      country: location.country,
      mobile: location.mobile,
      sellamount: location.amount,
      assetNames: location.assetNames,
      cust_id: location.cust_id,
      string: location.string ? location.string : "",
    });
  };

  console.log();
  // const [editOpen, setEditOpen] = useState(false);

  // const [editid, setDditid] = useState("");

  // const [editAmount, setaeditAmount] = useState("");

  // const [isin, setIsin] = useState("");

  // const editChange = (e) => {
  //   setaeditAmount(e.target.value);
  // };

  // const editRow = (e, item) => {
  //   setEditOpen(true);
  //   setDditid(item.id);
  //   setaeditAmount(item.amount);
  //   setIsin(item.ISIN);
  // };

  // const [deleteOpen, setDeleteOpen] = useState(false);

  // const deleteRow = (e, item) => {
  //   setDeleteOpen(true);
  //   setDditid(item.id);
  // };

  // const DeleteSell = () => {
  //   http
  //     .delete("updaterebalancemanualrequest/" + editid + "/")
  //     .then((res) => {
  //       setDeleteOpen(false);
  //       getData();
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // const handleClose = () => {
  //   setEditOpen(false);
  // };

  // const updateAmount = () => {
  //   http
  //     .patch("updaterebalancemanualrequest/" + editid + "/", {
  //       amount: editAmount,
  //     })
  //     .then((res) => {
  //       toast.success("Updated Successfully");
  //       setEditOpen(false);
  //       getData();
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const currentDate = new Date();

  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  const formattedDate = currentDate
    .toLocaleDateString("en-GB", options)
    .replace(/\//g, "."); // /regex/g  g--> find all matches

  return (
    <div>
      <div
        style={{
          display: "flex",
          columnGap: 20,
          flexWrap: "wrap",
          marginBottom: 30,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ height: 40 }}
          onClick={gotoManualadvices}
        >
          <ArrowBackIosSharp /> Back
        </Button>
        <p style={{ fontSize: 18, fontWeight: 500, margin: "10px 0" }}>
          <b>Create Advice</b> - Re-Balancing Preview
        </p>
      </div>
      <div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <b style={{ marginRight: 5 }}>Mobile No:</b> {location.mobile}
          <b style={{ marginLeft: 10, marginRight: 5 }}>Name:</b> {customerName}
        </div>
        <p style={{ textAlign: "right" }}>
          {BuyData.length > 0 ? (
            <Button
              variant="contained"
              color="primary"
              onClick={sendRebalanceAdvice}
              style={{ marginRight: 10 }}
            >
              Send Proposal
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={sendRebalanceAdvice}
              style={{ marginRight: 10 }}
            >
              Send Exit Plan
            </Button>
          )}
          <Button
            onClick={PDFeditfields}
            variant="contained"
            color="primary"
            style={{ marginRight: 10 }}
          >
            Edit PDF
          </Button>
          {BuyData.length > 0 ? (
            <Button variant="contained" color="primary">
              <PDFDownloadLink
                document={
                  <ReinvestingPlan
                    selltable={sellData}
                    buytable={BuyData}
                    custname={investorname}
                    pdftextabovetable={convertedContentAboveTable}
                  />
                }
                fileName={
                  "Re-investing Plan - " +
                  investorname +
                  " " +
                  formattedDate +
                  ".pdf"
                }
                style={{ color: "#fff", textDecoration: "none" }}
              >
                {({ blob, url, loading, error }) =>
                  loading ? "Generate Plan" : "Generate Plan"
                }
              </PDFDownloadLink>
            </Button>
          ) : (
            <Button variant="contained" color="primary">
              <PDFDownloadLink
                document={
                  <ExitPlan
                    selltable={sellData}
                    // buytable={BuyData}
                    custname={investorname}
                    pdftextabovetable={convertedContentAboveTable}
                    pdftextbelowtable={convertedContentBelowTable}
                  />
                }
                fileName={
                  "Exit Plan - " + investorname + " " + formattedDate + ".pdf"
                }
                style={{ color: "#fff", textDecoration: "none" }}
              >
                {({ blob, url, loading, error }) =>
                  loading ? "Generate Plan" : "Generate Plan"
                }
              </PDFDownloadLink>
            </Button>
          )}
        </p>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h3>
          Total Sell Advice:
          <span style={{ color: "#2835d5", fontWeight: 500 }}>
            &#8377; {location.amount}
          </span>
        </h3>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setShowSellPreview(true)}
          style={{ marginLeft: 10, height: "fit-content", borderRadius: 20 }}
        >
          Sell Preview
        </Button>
      </div>

      {setSellPreview && (
        <Dialog open={setSellPreview} className="dialouge_adaadvice">
          <p style={{ textAlign: "right", paddingRight: 10 }}>
            <CancelOutlined onClick={() => setShowSellPreview(false)} />
          </p>
          <div>
            <DataSheetGrid
              value={sellData.map((item) => ({ ...item, action: "Sell" }))}
              columns={previewSellcolumn}
            />
          </div>
        </Dialog>
      )}
      {/* ) : (
        <Button variant="contained" color="primary">
          <PDFDownloadLink
            document={
              <ReinvestingPlan
                selltable={sellData}
                buytable={BuyData}
                custname={investorname}
                pdftextabovetable={convertedContentAboveTable}
              />
            }
            fileName={
              "Re-investing Plan - " +
              investorname +
              " " +
              formattedDate +
              ".pdf"
            }
            style={{ color: "#fff", textDecoration: "none" }}
          >
            {({ blob, url, loading, error }) =>
              loading ? "Generate Sell Plan" : "Generate Sell Plan"
            }
          </PDFDownloadLink>
        </Button>
       */}

      {sellData.length > 0 ? (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {sellCols.map((item) => {
                  return (
                    <TableCell>
                      <TableSortLabel>{item.label}</TableSortLabel>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {sellData.map((row, index) => {
                return (
                  <TableRow>
                    {sellCols.map((cols, index) => {
                      const value = row[cols.id];
                      return (
                        <TableCell>
                          {cols.type === "date"
                            ? getDate(value)
                            : value
                            ? value
                            : "N/A"}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        ""
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3>
          Total Buy Advice:
          <span style={{ color: "#2835d5", fontWeight: 500 }}>
            &#8377; {location.amount}
          </span>
        </h3>
        <Button
          variant="contained"
          color="primary"
          onClick={preview}
          style={{
            marginLeft: 10,
            borderRadius: 20,
            height: "fit-content",
          }}
        >
          Buy Preview
        </Button>
      </div>

      {setPreview ? (
        <Dialog open={setPreview} className="dialouge_adaadvice">
          <p style={{ textAlign: "right", paddingRight: 10 }}>
            <CancelOutlined onClick={closepreview} />
          </p>
          <div>
            <DataSheetGrid
              value={BuyData.map((item) => ({ ...item, action: "Buy" }))}
              columns={previewBuycolumn}
            />
          </div>
        </Dialog>
      ) : (
        ""
      )}

      {BuyData.length > 0 ? (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {buyCols.map((item) => {
                  return (
                    <TableCell>
                      <TableSortLabel>{item.label}</TableSortLabel>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {BuyData.map((row, index) => {
                return (
                  <TableRow>
                    {buyCols.map((cols, index) => {
                      const value = row[cols.id];
                      return (
                        <TableCell>
                          {cols.type === "date"
                            ? getDate(value)
                            : value
                            ? value
                            : "N/A"}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        ""
      )}

      {showPDFeditfields ? (
        <Dialog
          open={showPDFeditfields}
          className="dialouge_adaadvice"
          fullWidth
          maxWidth="lg"
          minHeight="500px"
        >
          <DialogContent>
            <p
              style={{
                textAlign: "right",
                paddingRight: 10,
                cursor: "pointer",
              }}
            >
              <CancelOutlined onClick={() => setshowPDFeditfields(false)} />
            </p>
            <div>
              <div>
                <p style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <b style={{ marginRight: 5, width: "175px" }}>
                    Client Name for PDF:
                  </b>
                  <TextField
                    variant="outlined"
                    onChange={(e) => setpdfName(e.target.value)}
                    value={pdfName}
                  />
                </p>
                <p style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <b style={{ marginRight: 5, width: "200px" }}>
                    Add text above the table:
                  </b>
                  <div style={{ width: "100%" }}>
                    <Editor
                      defaultContentState={contentState}
                      // editorState={editorState}
                      onEditorStateChange={seteditorAbovetable}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      // toolbarHidden={true}
                      toolbar={{
                        options: ["inline"],
                        inline: {
                          options: ["bold"],
                        },
                      }}
                    />
                  </div>
                </p>

                <p style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <b style={{ marginRight: 5, width: "200px" }}>
                    Add text below the table:
                  </b>
                  <div style={{ width: "100%" }}>
                    <Editor
                      defaultContentState={contentState}
                      // editorState={editorState}
                      onEditorStateChange={seteditorBelowtable}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      // toolbarHidden={true}
                      toolbar={{
                        options: ["inline"],
                        inline: {
                          options: ["bold"],
                        },
                      }}
                    />
                  </div>
                </p>

                {/* <div>{convertedContentAboveTable}</div> */}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      ) : (
        ""
      )}

      {/* <Dialog
        open={editOpen}
        onClose={handleClose}
        style={{ padding: "20px 10px" }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <p style={{ textAlign: "right" }}>
            <CancelOutlined
              style={{ cursor: "pointer" }}
              onClick={handleClose}
            />
          </p>
        </DialogTitle>

        <DialogContent>
          <TextField
            value={isin}
            disabled
            label="ISIN Code"
            variant="outlined"
            style={{
              marginRight: 17,
              padding: 5,
            }}
          />
          <TextField
            value={editAmount}
            onChange={editChange}
            variant="outlined"
            label="amount"
            style={{ padding: 5 }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button
            autoFocus
            onClick={updateAmount}
            variant="contained"
            color="primary"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteOpen} onClose={handleClose}>
        <DialogContent>Are you sure you want to delete?</DialogContent>
        <DialogActions>
          <Button onClick={DeleteSell} variant="contained" color="primary">
            Yes
          </Button>
          <Button onClick={handleClose} variant="contained" color="primary">
            No
          </Button>
        </DialogActions>
      </Dialog> */}
    </div>
  );
}

export default RebalanceOverallData;
